import {
	EVENT_TYPE_COLORS,
	EVENT_TYPE_LABELS,
	getEventColor,
	getEventLabel,
	publicApi,
	apiClient,
} from "@trotroways/api";
import { env } from "@/env";

const API_BASE = env.VITE_API_URL ?? "http://localhost:8000/api/v1";
publicApi.configure(API_BASE);

export type PublicCity = {
	id: string;
	name: string;
	slug: string;
	country: string;
	timezone: string;
	lat: number | null;
	lon: number | null;
};

async function getCities(): Promise<PublicCity[]> {
	const data = await apiClient.request<PublicCity[] | { data: PublicCity[] }>("/cities", { auth: "public" });
	if (Array.isArray(data)) return data as PublicCity[];
	if (data && typeof data === "object" && "data" in (data as Record<string, unknown>)) {
		return (data as { data: PublicCity[] }).data ?? [];
	}
	return [];
}

export const api = {
	...publicApi,
	getCities,
};
export { EVENT_TYPE_COLORS, EVENT_TYPE_LABELS, getEventColor, getEventLabel };
export type {
	EventsResponse,
	EventType,
	PublicContactInfo as ContactInfo,
	PublicEvent as Event,
	PublicLocation as Location,
	RouteOption,
	RouteStep,
	SearchResult,
	Station,
	StationDetails,
	StationRoute,
} from "@trotroways/api";
